import React from 'react';
import { Assistant } from '@/types';
import { renderAssistantIcon } from '@/utils/RenderAssistantIcon';

// Tool display configuration
const TOOL_CONFIG: Record<string, { label: string }> = {
    extractEntities: { label: 'Analyzing your request...' },
    searchProducts: { label: 'Searching inventory...' },
    searchServices: { label: 'Finding services...' },
    webSearch: { label: 'Searching the web...' },
    organicProductSearch: { label: 'Searching marketplaces...' },
    searchInformation: { label: 'Searching local info...' },
};

interface LoadingIndicatorProps {
    assistant: Assistant;
    currentTool?: string | null;
}

export const LoadingIndicator: React.FC<LoadingIndicatorProps> = ({ assistant, currentTool }) => {
    const [displayedText, setDisplayedText] = React.useState('');

    // Use tool-specific text or default
    const text = currentTool && TOOL_CONFIG[currentTool]
        ? TOOL_CONFIG[currentTool].label
        : 'Thinking...';

    // Typewriter effect - repeating animation
    React.useEffect(() => {
        setDisplayedText('');
        let currentIndex = 0;
        let isPaused = false;

        const interval = setInterval(() => {
            if (isPaused) {
                // Skip during pause
                return;
            }

            if (currentIndex <= text.length) {
                setDisplayedText(text.slice(0, currentIndex));
                currentIndex++;
            } else {
                // Pause before resetting
                isPaused = true;
                setTimeout(() => {
                    currentIndex = 0;
                    isPaused = false;
                }, 500); // Wait before restarting
            }
        }, 25); // Adjust speed here (lower = faster)

        return () => clearInterval(interval);
    }, [text]);

    return (
        <div className="flex gap-2 justify-start">
            <div className="flex gap-2 max-w-[85%]">
                <div className="size-8 rounded-full flex items-center justify-center">
                    {renderAssistantIcon({
                        assistant,
                        size: 'md'
                    })}
                </div>
                <div className="px-2 py-1 flex items-center">
                    <span className="text-sm text-gray-400">
                        {displayedText}
                    </span>
                </div>
            </div>
        </div>
    );
};